import React from 'react';

/* Images */
import placeholder from '~/../img/vehicle-placeholder.jpg';

/* Icons */
import bouwjaarIcon from '~/../symbols/datum-fill.svg';
import tellerstandIcon from '~/../symbols/snelheid-kilometrage-fill.svg';
import brandstofIcon from '~/../symbols/brandstof-fill.svg';

/* Common */
import { Icon, Image } from '~/components/common';

/* Utilities */
import { getCloudimageUrl } from '~/utilities';

export default function ConversionFlowVehicle({ summary }) {
    const { vehicle } = summary || {};
    const image = vehicle?.image ? vehicle?.image : `${window.location.origin}${placeholder}`;
    const specs = [
        {
            key: 'construction_year',
            icon: bouwjaarIcon,
            value: vehicle?.bouwjaar,
        },
        {
            key: 'mileage',
            icon: tellerstandIcon,
            value: `${vehicle?.tellerstand?.toLocaleString('nl-NL')} km`,
        },
        {
            key: 'fuel_type',
            icon: brandstofIcon,
            value: vehicle?.brandstof,
        },
    ]

    return (
        <div className="row gutters-4 gutters-lg-6">
            <div className="col-12">
                <Image
                    className="img-fluid"
                    src={getCloudimageUrl(image, {w: 540, h: 405, func: 'crop'})}
                    srcSet={`${getCloudimageUrl(image, {w: 1080, h: 810, func: 'crop'})} 2x`}
                    alt="Vehicle image"
                    width={540}
                    height={405}
                    sources={[
                        {
                            set: {
                                '1x': getCloudimageUrl(image, {w: 405, h: 304, func: 'crop'}),
                                '2x': getCloudimageUrl(image, {w: 810, h: 608, func: 'crop'}),
                            },
                            media: '(min-width: 1920px)',
                        },
                        {
                            set: {
                                '1x': getCloudimageUrl(image, {w: 360, h: 270, func: 'crop'}),
                                '2x': getCloudimageUrl(image, {w: 720, h: 540, func: 'crop'}),
                            },
                            media: '(min-width: 1680px)',
                        },
                        {
                            set: {
                                '1x': getCloudimageUrl(image, {w: 420, h: 315, func: 'crop'}),
                                '2x': getCloudimageUrl(image, {w: 840, h: 630, func: 'crop'}),
                            },
                            media: '(min-width: 1440px)',
                        },
                        {
                            set: {
                                '1x': getCloudimageUrl(image, {w: 370, h: 278, func: 'crop'}),
                                '2x': getCloudimageUrl(image, {w: 740, h: 556, func: 'crop'}),
                            },
                            media: '(min-width: 1280px)',
                        },
                        {
                            set: {
                                '1x': getCloudimageUrl(image, {w: 280, h: 210, func: 'crop'}),
                                '2x': getCloudimageUrl(image, {w: 560, h: 420, func: 'crop'}),
                            },
                            media: '(min-width: 992px)',
                        },
                        {
                            set: {
                                '1x': getCloudimageUrl(image, {w: 320, h: 240, func: 'crop'}),
                                '2x': getCloudimageUrl(image, {w: 640, h: 480, func: 'crop'}),
                            },
                            media: '(min-width: 768px)',
                        },
                        {
                            set: {
                                '1x': getCloudimageUrl(image, {w: 520, h: 390, func: 'crop'}),
                                '2x': getCloudimageUrl(image, {w: 1040, h: 780, func: 'crop'}),
                            },
                            media: '(min-width: 600px)',
                        },
                    ]}
                />
            </div>
            <div className="col-12">
                <p className="h6">
                    <b>{vehicle?.brand}</b>
                    <br />
                    {vehicle?.model} {vehicle?.type}
                </p>
            </div>
            <div className="col-12">
                <div className="row gutters-8 gutters-xxl-6">
                    {specs?.map((spec) => (
                        <div key={spec?.key} className="col-auto">
                            <div className="d-flex flex-column flex-xxl-row align-items-xxl-center">
                                <Icon
                                    theme="primary"
                                    url={spec?.icon?.url}
                                    size={32}
                                    className={``}
                                />
                                <p className="text--sm mt-1 mt-xxl-0 ml-xxl-2">
                                    {spec?.value}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}
